let fade;

export async function fadeOut(app) {
    fade = new PIXI.Graphics();
    fade.rect(0, 0, app.renderer.width, app.renderer.height);
    fade.fill(0xffffff);
    fade.alpha = 0;
    fade.zIndex = 99999;
    app.stage.addChild(fade);
    await anime({ targets: fade, alpha: 1, easing: 'linear', duration: 500 }).finished;
}

export async function fadeIn(app) {
    await anime({ targets: fade, alpha: 0, easing: 'linear', duration: 750 }).finished;
    app.stage.removeChild(fade);
}
